export default __webpack_public_path__ + "static/media/theme-light.66fd1d2f.svg";